module.exports = __webpack_public_path__ + "img/1-2.bcd9a71e.jpg";